export enum ContainerType {
  Acquisition = 'acquisition',
  Analysis = 'analysis',
  Collection = 'collection',
  Group = 'group',
  Project = 'project',
  Session = 'session',
  Subject = 'subject',
}
